import React from "react";
import Header from "../../../../Components/Header";
import { Helmet } from "react-helmet";
import AddVoucher from "./AddVoucher";

function NewPeriodClosingVoucher() {
  return (
    <div className="d-flex flex-column" style={{ minHeight: "100vh" }}>
      <Helmet>
        <title>New Period Closing Voucher</title>
      </Helmet>
      <Header />
      <div
        className="container-fluid maindiv d-flex flex-column "
        style={{ flexGrow: "1" }}
      >
        <AddVoucher />
      </div>
    </div>
  );
}

export default NewPeriodClosingVoucher;